/**
 * Start DateとEnd Dateを「YYYY-MM-DD」の形で受け取って、
 * 日付クエリの形（[2020-02-20 to +]など）に整形して返す
 * @param start: 'YYYY-MM-DD'
 * @param end: 'YYYY-MM-DD'
 * @returns query: string
 */
const getCertIssueDateQuery = (start: string, end: string): string => {
  if (start === '' && end === '') {
    return '';
  } else {
    const startDate: string = start !== '' ? start : '*';
    const endDate: string = end !== '' ? end : '*';
    const query: string = '[' + startDate + ' TO ' + endDate + ']';
    return query;
  }
};

export default getCertIssueDateQuery;
